import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import('@/layout'),
    children: [
      {
        path: "/",
        component: () => import('@/views/home.vue')
      },
      {
        path: "/my",
        component: () => import('@/views/my.vue')
      },
      {
        path: "/introduce",
        component: () => import('@/views/introduce.vue')
      },
      {
        path: "/principle",
        component: () => import('@/views/principle.vue')
      },
      {
        path: "/resolve",
        component: () => import('@/views/resolve.vue')
      },
      {
        path: "/equipment",
        component: () => import('@/views/equipment.vue')
      },
      {
        path: "/news",
        component: () => import('@/views/news.vue'),
        children:[
          {
            path:'info',
            component:() => import('@/views/news-info.vue')
          }
        ]
      },
      {
        path: "/email",
        component: () => import('@/views/email.vue')
      }
    ]
  }
];

// 解决重复路由跳转的报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
